// ===========================================
// Canonical Project Types (must mirror the Portal + backend)
// ===========================================
// The Portal stores projectType as SHORT codes ('Water', 'Fire', 'Mold', …).
// Commission rules must be entered using these exact labels or the backend
// exact-match (normalizeProjectType) won't line up. This list drives the rule
// form's dropdown so admins can't accidentally type a non-matching label.
// Keep in sync with shared-functions/src/crm/utils/projectType.ts.

export const PROJECT_TYPE_OPTIONS: string[] = [
  'Water',
  'Fire',
  'Mold',
  'Bio',
  'Asbestos',
  'Contents',
  'Rebuild',
  'Remodel',
  'Roof',
  'Roof Tarp',
  'Board Up',
  'BINSR',
  'Warranty',
  'Testing Fees',
  'Inspection Only',
];

const ALIASES: Record<string, string> = {
  'water damage': 'water',
  'water mitigation': 'water',
  'fire damage': 'fire',
  'fire & smoke': 'fire',
  smoke: 'fire',
  'mold remediation': 'mold',
  'mold removal': 'mold',
  biohazard: 'bio',
  'bio hazard': 'bio',
  reconstruction: 'rebuild',
  reconstruct: 'rebuild',
  'contents/pack out': 'contents',
  'pack out': 'contents',
  'board-up': 'board up',
};

/**
 * Normalize a project-type string to a canonical comparison key
 * (case-insensitive, whitespace-collapsed, alias-aware).
 */
export function normalizeProjectType(value: string | null | undefined): string {
  const raw = (value ?? '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  if (!raw) return '';
  return ALIASES[raw] ?? raw;
}
